/* Complete your pack - add-on panel behaviour.
   One cached file, one custom element, works for every instance on the page.

   The form is resolved at submit time, never cached. Dawn re-renders the buy
   section whenever a variant changes, so a reference taken at load time goes
   stale and the panel silently stops working.

   Add-ons are posted first, then the browser submits the form as normal. That
   leaves Dawn in charge of adding the main product and opening the cart, so a
   problem in here can slow the upsell down but can never break add to cart. */

(function () {
  if (customElements.get('complete-pack')) return;

  class CompletePack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.currency = this.dataset.currency || 'AUD';
      this.totalEl = this.querySelector('[data-cyp-total]');
      this.totalText = this.querySelector('[data-cyp-total-text]');
      this.errorEl = this.querySelector('[data-cyp-error]');

      this.addEventListener('change', this.onChange.bind(this));
      this.refresh();

      this._onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this._onSubmit, true);
    }

    disconnectedCallback() {
      if (this._onSubmit) document.removeEventListener('submit', this._onSubmit, true);
    }

    rows() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-cyp-row]'));
    }

    /* Is this form the one this panel belongs to? Resolved fresh every time. */
    belongsTo(form) {
      if (!form || !form.getAttribute) return false;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return false;
      var scope = form.closest('.product__info-container') ||
                  form.closest('.shopify-section') ||
                  document.body;
      return scope.contains(this);
    }

    onChange(event) {
      var row = event.target.closest && event.target.closest('[data-cyp-row]');
      if (!row) return;

      if (event.target.matches('[data-cyp-select]')) {
        var opt = event.target.options[event.target.selectedIndex];
        var priceEl = row.querySelector('[data-cyp-price]');
        if (opt && priceEl && opt.dataset.money) priceEl.textContent = opt.dataset.money;
        var box = row.querySelector('[data-cyp-checkbox]');
        if (box) box.checked = true;
      }

      this.clearError();
      this.refresh();
    }

    selected() {
      var items = [];
      this.rows().forEach(function (row) {
        var box = row.querySelector('[data-cyp-checkbox]');
        if (!box || !box.checked) return;
        var select = row.querySelector('[data-cyp-select]');
        var opt = select ? select.options[select.selectedIndex] : null;
        var id = select ? select.value : box.value;
        if (!id) return;
        items.push({
          id: Number(id),
          quantity: 1,
          cents: Number(opt ? opt.dataset.cents : box.dataset.cents) || 0
        });
      });
      return items;
    }

    refresh() {
      if (!this.totalEl || !this.totalText) return;
      var items = this.selected();
      if (!items.length) {
        this.totalEl.hidden = true;
        return;
      }
      var cents = items.reduce(function (sum, item) { return sum + item.cents; }, 0);
      this.totalEl.hidden = false;
      this.totalText.textContent =
        items.length + (items.length === 1 ? ' add-on' : ' add-ons') + ' · ' + this.money(cents);
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    busy(state) {
      this.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    reset() {
      this.rows().forEach(function (row) {
        var box = row.querySelector('[data-cyp-checkbox]');
        if (box) box.checked = false;
      });
      this.refresh();
    }

    post(items) {
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data && data.status)) {
            throw new Error((data && data.description) || 'Could not add');
          }
          return data;
        });
      });
    }

    resubmit(form) {
      form.dataset.cypPending = '1';
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    onSubmit(event) {
      var form = event.target;

      /* Our own resubmit coming back around. Let it through untouched. */
      if (form.dataset && form.dataset.cypPending === '1') {
        form.dataset.cypPending = '';
        return;
      }

      if (!this.belongsTo(form)) return;
      if (event.defaultPrevented) return;

      var items = this.selected();
      if (!items.length) return;

      var addons = items.map(function (item) {
        return { id: item.id, quantity: item.quantity };
      });

      event.preventDefault();
      event.stopPropagation();

      var self = this;
      this.busy(true);
      this.clearError();

      this.post(addons)
        .then(function () {
          self.reset();
        })
        .catch(function () {
          self.showError('We could not add the extras. Your main item is still going in.');
        })
        .then(function () {
          self.busy(false);
          self.resubmit(form);
        });
    }
  }

  customElements.define('complete-pack', CompletePack);
})();
